import React, { useState, useContext } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { AuthContext } from './AuthProvider';
import { API_BASE_URL } from '../dppApi';

function UpdateJewelleryDetails() {

    const navigate = useNavigate();
    const location = useLocation();
    const data = location.state;

    const [selectedFile, setSelectedFile] = useState(null);
    const [receiptFile, setReceiptFile] = useState(null);
    const [certificateFile, setCertificateFile] = useState(null);
    const [appraisalFile, setAppraisalFile] = useState(null);

    const [previewUrl, setPreviewUrl] = useState(null);
    const [receiptPreviewUrl, setReceiptPreviewUrl] = useState(null);
    const [certificatePreviewUrl, setCertificatePreviewUrl] = useState(null);
    const [appraisalPreviewUrl, setAppraisalPreviewUrl] = useState(null);

    const [description, setDescription] = useState('');
    const [storageLocation, setStorageLocation] = useState('');
    const [history, setHistory] = useState('');

    const { user, isAuthenticated, accessToken } = useContext(AuthContext);

    const handleFileChange = (event) => {
        const file = event.target.files[0];
        setSelectedFile(file);

        if (file) {
            const objectUrl = URL.createObjectURL(file);
            setPreviewUrl(objectUrl);
        } else {
            setPreviewUrl(null);
        }
    };

    const handleReceiptFileChange = (event) => {
        const file = event.target.files[0];
        setReceiptFile(file);

        if (file) {
            const objectUrl = URL.createObjectURL(file);
            setReceiptPreviewUrl(objectUrl);
        } else {
            setReceiptPreviewUrl(null);
        }
    };

    const handleCertificateFileChange = (event) => {
        const file = event.target.files[0];
        setCertificateFile(file);

        if (file) {
            const objectUrl = URL.createObjectURL(file);
            setCertificatePreviewUrl(objectUrl);
        } else {
            setCertificatePreviewUrl(null);
        }
    };

    const handleAppraisalFileChange = (event) => {
        const file = event.target.files[0];
        setAppraisalFile(file);

        if (file) {
            const objectUrl = URL.createObjectURL(file);
            setAppraisalPreviewUrl(objectUrl);
        } else {
            setAppraisalPreviewUrl(null);
        }
    };


    const handleUpload = async () => {

        const formData = new FormData();
        formData.append("picture", selectedFile);
        formData.append("receipt", receiptFile);
        formData.append("certificate", certificateFile);
        formData.append("appraisal", appraisalFile);
        formData.append("description", description);
        formData.append("storageLocation", storageLocation);
        formData.append("history", history);
        formData.append("username", user);
        formData.append("itemKey", data.key);

        console.log(formData)

        try {
            const response = await
                fetch(`${API_BASE_URL}/api/update-jewellery`,
                //fetch('http://ec2-54-167-84-208.compute-1.amazonaws.com:5000/api/update-jewellery',
                    {
                        method: 'PUT',
                        body: formData
                    });

            const data = await response.json();
            console.log('Data from Flask:', data);
            navigate('/jewellery');

        } catch (error) {
            console.error('Error uploading file:', error);
        }
    };

    const handleUploadJewelleryImage = () => {
        document.getElementById('jewelleryImage').click();
    }

    const handleUploadReceiptImage = () => {
        document.getElementById('receiptImage').click();
    }

    const handleUploadCertificateImage = () => {
        document.getElementById('certificateImage').click();
    }

    const handleUploadAppraisalImage = () => {
        document.getElementById('appraisalImage').click();
    }


    return (
        <div class="App-body">
            <div>
                <input type="file" accept="image/*" onChange={handleFileChange}
                    id="jewelleryImage" style={{ display: 'none' }} />
                <button id="uploadJewelleryImageButton"
                    onClick={handleUploadJewelleryImage}><span>Upload Jewellery Image</span></button>
                {previewUrl && (
                    <img src={previewUrl} alt="Preview" style={{ width: '200px', marginTop: '10px' }} />
                )}</div>
            <div>
                <input
                    type="text"
                    placeholder="Description"
                    value={description}
                    className="text-box-style"
                    onChange={(e) => setDescription(e.target.value)}
                /></div>
            <div>
                <input
                    type="text"
                    placeholder="Storage Location"
                    value={storageLocation}
                    className="text-box-style"
                    onChange={(e) => setStorageLocation(e.target.value)}
                /></div>
            <div>
                <input
                    type="text"
                    placeholder="History"
                    value={history}
                    className="text-box-style-large"
                    onChange={(e) => setHistory(e.target.value)}
                /></div>
            <div>
                <input type="file" accept="image/*" onChange={handleReceiptFileChange}
                    id="receiptImage" style={{ display: 'none' }} />
                <button id="uploadReceiptImageButton"
                    onClick={handleUploadReceiptImage}><span>Upload Receipt Image</span></button>
                {receiptPreviewUrl && (
                    <img src={receiptPreviewUrl} alt="Preview" style={{ width: '200px', marginTop: '10px' }} />
                )}</div>

            <div>
                <input type="file" accept="image/*" onChange={handleCertificateFileChange}
                    id="certificateImage" style={{ display: 'none' }} />
                <button id="uploadCertificateImageButton"
                    onClick={handleUploadCertificateImage}><span>Upload Certificate Image</span></button>
                {certificatePreviewUrl && (
                    <img src={certificatePreviewUrl} alt="Preview" style={{ width: '200px', marginTop: '10px' }} />
                )}
            </div>

            <div>
                <input type="file" accept="image/*" onChange={handleAppraisalFileChange}
                    id="appraisalImage" style={{ display: 'none' }} />
                <button id="uploadAppraisalImageButton"
                    onClick={handleUploadAppraisalImage}><span>Upload Appraisal Image</span></button>
                {appraisalPreviewUrl && (
                    <img src={appraisalPreviewUrl} alt="Preview" style={{ width: '200px', marginTop: '10px' }} />
                )}</div>
            <div><button onClick={handleUpload}>Update Jewellery</button></div>
        </div>
    );
}

export default UpdateJewelleryDetails;
